<template>
  <div class="MainPageContent" ref="MainPageContent">
    <!-- 导航栏 -->
    <header class="headerBox">
      <div class="headerContent">
        <img class="logo" src="@/assets/logo.png" alt="" />
        <div class="rightnav">
          <!-- <span>品牌发展</span> -->
          <div class="aboxinfo" v-for="(item, index) in aList">
            <a
              :style="{ color: isAshow == item.href ? '#54b000' : '' }"
              @click="Maodian(item.href)"
              >{{ item.title }}</a
            >
            <div class="lineinfo" v-if="isAshow == item.href"></div>
          </div>
        </div>
      </div>
    </header>
    <div style="height: 80px"></div>
    <!-- 首屏 -->
    <!-- <main class="FirstScreen" ref="FirstScreen" v-show="!firstShow"> -->
    <main class="FirstScreen" ref="FirstScreen" id="FirstScreen">
      <img class="Mouse" v-cloak src="@/assets/image4.png" alt="" />
      <div
        class="flootContent showzhezhao"
        ref="topflootContent"
        v-if="isflootContent"
      >
        <img
          class="closeinfo"
          @click="isflootContent = false"
          src="@/assets/close.png"
          alt=""
        />
        <div class="banner_footer">
          <p>
            <a :href="shipinjingying" target="_blank"
              >预包装食品备案编号；YB21106180209535 |</a
            >
            <a :href="yiliaoqixie" target="_blank"
              >医疗器械经营备案号：京丰食药监械经营备20150001号 |
            </a>
            <a :href="hulianwang" target="_blank">
              药品医疗器械信息服务备案：(京)网药械信息备字(2025)第00210号 |</a
            >
            <a :href="jingshiyaowang" target="_blank">
              京食药网食备202120050
            </a>
          </p>
          <p>
            <span>©2007-{{ currentYearInfo }} 家家乐购（北京）科技有限公司 -</span>
            <a href="http://beian.miit.gov.cn/" target="_blank">
              京ICP备08006683号
            </a>
            <a class="jwga" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010602100198" target="_blank">京公网安备 11010602100198号</a>
            <!-- <a href="javascript:;">
              本网站用字经北京北大方正电子有限公司授权许可
            </a> -->
          </p>
        </div>
        <!-- 底部图片 -->
        <div class="banner_footerImg">
          <a
            href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202011062300006"
            target="_blank"
          >
            <img src="@/assets/image2.png" alt="" />
          </a>
          <a :href="yingyezhizhao" target="_blank">
            <img class="rightimg" src="@/assets/image1.png" alt="" />
          </a>
        </div>
      </div>
    </main>
    <!-- <div v-show="firstShow"> -->
    <div>
      <!-- 品牌介绍 -->
      <div class="BrandIntroduction" id="BrandIntroduction">
        <div class="BrandIntroductionBox">
          <header class="headerinfo showdh" ref="headerinfo">品牌介绍</header>
          <div class="navbarbox showdh" ref="navbarbox">
            <div
              class="navitem"
              :style="{
                color: index == ppcurrentindex ? '#6FBA2C' : '',
                fontWeight: index == ppcurrentindex ? '600' : '',
              }"
              v-for="(item, index) in pplist"
              @click="ppclick(item.title, index)"
            >
              <div>{{ item.title }}</div>
              <div class="luxian" v-if="index == ppcurrentindex"></div>
            </div>
          </div>
          <div class="hrinfo showdh" ref="hrinfo"></div>
          <div class="futitle showdh" ref="futitle">{{ pptitle }}</div>
          <div class="mainbox showdh" ref="mainbox" v-if="ppcurrentindex == 0">
            <div class="textbox">
              <p>
                西藏家家乐购信息技术股份有限公司（以下简称公司）成立于2007年10月，注册地为拉萨市柳梧新区国际总部城，注册资本3366万。公司全资控股的子公司有10家，投资股权超过50%的子公司1家。子公司中包含1家国家高新技术企业，1家中关村科技园区高新技术公司。公司及旗下分子公司目前员工共计500余人。
              </p>
              <p>
                公司主要所属行业为电子商务，主营业务为销售健康食品、医疗器械以及健康用品，并向消费者提供健康管理、健康咨询服务。
              </p>
              <p>
                公司的定位是成为领先的会员制健康产品销售及健康服务平台；公司的愿景是专注做中国家庭健康管理第一品牌。
              </p>
              <p>
                公司及旗下分子公司的主要服务经营对象为有健康服务需求和健康产品购买需求的人群，公司的客户遍布全国各地，目前公司所服务的会员累计人数300余万人。
              </p>
              <p>
                公司及旗下分子公司从成立之初到现在，累计获得多个相关资质和荣誉。
              </p>
            </div>
            <div class="imgbox">
              <img src="@/assets/logoshiwu.png" alt="" />
            </div>
          </div>
          <div class="mainbox" v-if="ppcurrentindex == 1">
            <div class="textbox">
              <p>
                公司从成立至今，包括旗下分子公司累计向各地方税务机关及海关纳税总额过亿元，公司在主营业务的注册地连续多年被评定为A级纳税信用级别。
              </p>
              <p>
                公司及旗下分子公司成立之初主要是以电视和平面媒体进行客户引流并进行发展，随着业务发展和市场变化，公司及旗下分子公司逐渐从线下业务的经营模式转变为多渠道的业务经营模式，从而使公司业务更加灵活，未来发展空间更大。
              </p>
              <p>
                公司及旗下分子公司从成立之初代销几十种国内健康食品，目前发展到累计经营国内保健食品、医疗器械、传统滋补品百余种，跨境海外膳食营养补充剂、健康用品累计百余种，定制OEM产品十余种，公司正逐步利用自身稳定的供应链优势满足客户更多的健康需求。
              </p>
              <p>
                为了适应跨境业务的发展和提升客户满意度，公司及旗下分子公司从成立之初仅有一个自主运营的仓储中心，目前发展到涉及北京、河北、福州、深圳等多个产品中心仓，并在天猫、京东、唯品会、拼多多的体系下另行布局了十余个货物管理仓库。
              </p>
              <p>
                为了满足客户多样的个性化需求，适应公司业务多渠道的特性，并致力于整合公司业务流和数据流，公司为此组建了一个20余人的技术团队，为公司研发全套的客户管理、业务操作和分析系统，与此同时申报获取了几十个软件著作权。公司非常重视核心技术研发能力，并相信这是驱动公司快速发展的重要布局之一。
              </p>
              <p>
                在近年的经营发展中，公司发展培养建立了一个经验丰富的电商运营团队，不仅使公司及旗下分子公司在天猫平台的品牌POP店运营到行业类目排名前列，并且还收到诸多大品牌店铺的青睐，2020-2021公司及旗下分子公司凭借很好的运营能力优势承接了年销量在8-10亿的几个品牌店铺的国内独家代理运营权，这将在未来给公司自身的线上业务发展带来更多的机会。
              </p>
              <p>
                为了满足客户多样的交互习惯，以及贯彻为客户一对一专业健康咨询服务的理念，公司在北京、山东、南京成立了多个客户服务中心，具备专业健康服务能力的客户服务专员人数达到几百余人。
              </p>
            </div>
            <div class="imgbox">
              <img style="margin-bottom: 50px" src="@/assets/zxz.png" alt="" />
              <img src="@/assets/kf.png" alt="" />
            </div>
          </div>
          <div class="mainbox" v-if="ppcurrentindex == 2">
            <div class="textbox">
              <p>
                根据公司的业务规划，公司及旗下分子公司未来3-5年的产品品线将在现有基础上进行增加，新增产品线将涵盖儿童、孕妇、运动、轻食等多个领域；还将扩充百余种包含跨境电商健康产品在内的产品类目，逐步完善搭建以家庭为核心的全健康营养服务平台。
              </p>
              <p>
                公司将进一步扩大跨境电商业务版图，加强巩固供应链优势，计划再新增十余个全球产品一线供应商，以确保公司产品线按计划搭建。
              </p>
              <p>
                随着公司代运营业务不断的发展壮大，公司未来3-5年将新增会员200万人，从而也会增加相关健康服务专员及线上客服人员百余人。为了匹配公司的发展速度，进一步提升客户满意度和提升运营效率，公司将计划再设立多个货物仓储及发货管理中心，将确保其运营能力能有效覆盖全国。
              </p>
            </div>
            <div class="imgbox">
              <img src="@/assets/yijiaren.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="CoreCulture" id="CoreCulture">
        <div class="CoreCultureContent">
          <div class="title showdh" ref="hxwhref">我们的核心文化</div>
          <div class="slogan showdh" ref="qywwxsloaan">
            <img src="@/assets/11.png" alt="" />
            <div class="text">
              崇尚“舍得”文化永持一颗乐观感恩之心，将一份健康的快乐，施与四方。
            </div>
          </div>
          <div class="imgContent showdh" ref="qyimgContent">
            <div class="imgItem">
              <img src="@/assets/Group30.png" alt="" />
              <div class="h1">我们的核心竞争力</div>
              <div class="h2">真品 真诚 真情</div>
            </div>
            <div class="imgItem">
              <img src="@/assets/Group31.png" alt="" />
              <div class="h1">我们的行动纲领</div>
              <div class="h2">创新求变 谋事为先</div>
            </div>
            <div class="imgItem">
              <img src="@/assets/Group32.png" alt="" />
              <div class="h1">我们的使命</div>
              <div class="h2">传播健康 造福民众</div>
            </div>
            <div class="imgItem">
              <img src="@/assets/Group33.png" alt="" />
              <div class="h1">我们的愿景</div>
              <div class="h2">成为中国家庭首选</div>
              <div class="h2">健康管理第一品牌</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 资质荣誉 -->
      <div class="qualification" id="qualification">
        <div class="qualificationContent">
          <div class="headerzz showdh" ref="headerzz">
            <div>公司及旗下分子公司</div>
            <div>历年来获得的部分荣誉或资质</div>
          </div>
          <div class="contentinfomain showdh" ref="contentinfomain">
            <div class="mainitemt" v-for="(item, index) in qualificationList">
              <div class="dateinfo">{{ item.date }}</div>
              <div class="infocontenta">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 加入我们 -->
      <div class="JoinUs" id="JoinUs">
        <div class="JoinUsContent">
          <div class="title showdh" ref="JoinUsContenttitile">加入我们</div>
          <div class="navContent showdh" ref="navContent">
            <div
              class="item"
              v-for="item in joinUsList"
              @click="itemClick(item.title)"
              :class="flag == item.title ? 'showColor' : ''"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="card showdh" ref="cardinfoq">
            <img
              class="Polygon6"
              ref="Polygon6"
              src="@/assets/topJ.png"
              alt=""
            />
            <div class="title" ref="widthTielt">{{ flag }}</div>
            <!-- <div
              class="line"
              :style="{ width: linWidth === 0 ? '' : linWidth + 'px' }"
            ></div> -->
            <template v-for="item in dutyList">
              <div class="duty">{{ item.title }}</div>
              <div class="dutyBox">
                <p class="dutyitem" v-for="item2 in item.list">
                  {{ item2.matter }}
                </p>
              </div>
            </template>
            <div class="E-mail">投递邮箱：hr@jjlg.net</div>
          </div>
          <!-- 照片墙 -->
          <div class="PhotoWall showdh" ref="PhotoWall">
            <div class="left">
              <img @click="checkImg(0)" :src="PhotoWallList[0].url" alt="" />
            </div>
            <div class="right">
              <div class="top">
                <img @click="checkImg(1)" :src="PhotoWallList[1].url" alt="" />
                <img @click="checkImg(2)" :src="PhotoWallList[2].url" alt="" />
                <img @click="checkImg(3)" :src="PhotoWallList[3].url" alt="" />
              </div>
              <div class="bottom">
                <img @click="checkImg(4)" :src="PhotoWallList[4].url" alt="" />
                <img
                  @click="checkImg(5)"
                  class="Maskgroup5"
                  :src="PhotoWallList[5].url"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 照片墙遮罩 -->
      <div class="maskImg" v-if="showimgmask" @click="showimgmask = false">
        <div class="imgbox" @click.stop="">
          <img
            class="maskimg"
            :src="AllPhotoWallList[currentindex].url"
            alt=""
          />
          <img
            @click="showimgmask = false"
            class="close"
            src="@/assets/close.png"
            alt=""
          />
          <!-- <div  class="maskimg"></div> -->
          <div class="left w" @click="imgclickinfo(0)">&lt</div>
          <div class="right w" @click="imgclickinfo(1)">&gt</div>
        </div>
      </div>
      <!-- 商城首页 -->
      <div class="JumpShop" id="JumpShop">
        <div class="JumpShopContent">
          <div class="leftBox" @click="backShop(0)">
            <div class="title">国内严选</div>
            <div class="bottombox" v-if="false">
              <div class="leftinfo">进入家家乐购官网商城</div>
              <img
                class="tiaoxaingtou"
                src="@/assets/tiaoxaingtou.png"
                alt=""
              />
            </div>
          </div>
          <div class="rightBox" @click="backShop(1)">
            <div class="title">全球精选</div>
            <div class="bottombox"  v-if="false">
              <div class="leftinfo">进入家家乐环球号商城</div>
              <img
                class="tiaoxaingtou"
                src="@/assets/tiaoxaingtou.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="flootContent">
        <div class="banner_footer">
          <p>
            <a :href="shipinjingying" target="_blank"
              >预包装食品备案编号；YB21106180209535 |</a
            >
            <a :href="yiliaoqixie" target="_blank"
              >医疗器械经营备案号：京丰食药监械经营备20150001号 |
            </a>
            <a :href="hulianwang" target="_blank">
              药品医疗器械信息服务备案：(京)网药械信息备字(2025)第00210号 |</a
            >
            <a :href="jingshiyaowang" target="_blank">
              京食药网食备202120050
            </a>
          </p>
          <p>
            <span>©2007-{{ currentYearInfo }} 家家乐购（北京）科技有限公司 -</span>
            <a href="http://beian.miit.gov.cn/" target="_blank">
              京ICP备08006683号
            </a>
            <a class="jwga" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010602100198" target="_blank">京公网安备 11010602100198号</a>
            <!-- <a href="javascript:;">
              本网站用字经北京北大方正电子有限公司授权许可
            </a> -->
          </p>
        </div>
        <!-- 底部图片 -->
        <div class="banner_footerImg">
          <a
            href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202011062300006"
            target="_blank"
          >
            <img src="@/assets/image2.png" alt="" />
          </a>
          <a :href="yingyezhizhao" target="_blank">
            <img class="rightimg" src="@/assets/image1.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, nextTick } from "vue";
import { handelYear } from "./Hooks/useCurrentYear";
const { currentYearInfo } = handelYear();
const Polygon6 = ref(null);
const isflootContent = ref(true);
const firstShow = ref(true);
const slidingContent = ref(null);
const MainPageContent = ref(null);
const FirstScreen = ref(null);
const widthTielt = ref(null);
const flag = ref("新媒体运营经理");
const isVideo = ref(false);
const joinUsList = reactive([
  { title: "新媒体运营经理" },
  { title: "产品经理" },
  { title: "活动策划" },
  { title: "销售顾问" },
]);
/*
 */
// PhotoWallList@/assets/Maskgroup.png
const PhotoWallList = [
  {
    url: require("@/assets/Maskgroup.png"),
  },
  {
    url: require("@/assets/Maskgroup(1).png"),
  },
  {
    url: require("@/assets/Maskgroup(2).png"),
  },
  {
    url: require("@/assets/Maskgroup(3).png"),
  },
  {
    url: require("@/assets/Maskgroup(4).png"),
  },
  {
    url: require("@/assets/Maskgroup(5).png"),
  },
];
const AllPhotoWallList = [
  { url: require("@/assets/zhaopq/i1.jpg") },
  { url: require("@/assets/zhaopq/i2.jpg") },
  { url: require("@/assets/zhaopq/i3.jpg") },
  { url: require("@/assets/zhaopq/i4.jpg") },
  { url: require("@/assets/zhaopq/i5.jpg") },
  { url: require("@/assets/zhaopq/i6.jpg") },
  { url: require("@/assets/zhaopq/i7.jpg") },
  { url: require("@/assets/zhaopq/i8.jpg") },
  { url: require("@/assets/zhaopq/i9.jpg") },
  { url: require("@/assets/zhaopq/i10.jpg") },
  { url: require("@/assets/zhaopq/i11.jpg") },
];
const showimgmask = ref(false);
const currentindex = ref();
const checkImg = (i) => {
  showimgmask.value = true;
  currentindex.value = i;
};
const imgclickinfo = (i) => {
  const AllPhotoWallListlength = AllPhotoWallList.length - 1;
  if (i == 0) {
    if (currentindex.value == 0) {
      currentindex.value = AllPhotoWallListlength;
    } else {
      currentindex.value--;
    }
  } else {
    if (AllPhotoWallListlength == currentindex.value) {
      currentindex.value = 0;
    } else {
      currentindex.value++;
    }
  }
};
const dutyList = reactive([
  {
    title: "【岗位职责】",
    list: [
      {
        matter:
          "1、搭建微信公众号、小红书、今日头条的运营工具矩阵。搭建起相匹配的产品、内容、活动、会员增长、服务为联动的的运营策略规划。分析同行业的媒体热点以及内容，研究用户喜好调整优化；提高粉丝量，增加用户粘性；",
      },
      {
        matter:
          "2、负责平台日常内容输出、粉丝互动管理等工作（活动运营、热点话题、爆文运营等）策划产品活动，输出文案，把控微信公众号、小红书、今日头条等推动渠道工作执行企业账号运营管理，提高用户增长和引流转化等工作；",
      },
      {
        matter: "3、建立公司内容资料库，整理产品文案定期更新，并与粉丝互动；",
      },
      {
        matter: "4、完成领导安排的其他事务。",
      },
    ],
  },
  {
    title: "【任职要求】",
    list: [
      {
        matter:
          "1、本科以上学历，有0-1搭建新媒体平台，包括今日头条、微信公众号、小红书、抖音等运营整体思路;网感好、选题策划能力强、擅长数据分析、有涨粉、转化逻辑，了解多个新媒体平台运营规则；",
      },
      {
        matter:
          "2、优秀的沟通能力、团队管理及协作能力、执行力、有耐心、抗压能力强、思维活跃、有亲和力、了解中老年用户心理；",
      },
      {
        matter: "3、有保健品类、美妆类行业经验，食品营养学专业者优先。",
      },
    ],
  },
]);
const LlisInfo = {
  one: [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、搭建微信公众号、小红书、今日头条的运营工具矩阵。搭建起相匹配的产品、内容、活动、会员增长、服务为联动的的运营策略规划。分析同行业的媒体热点以及内容，研究用户喜好调整优化；提高粉丝量，增加用户粘性；",
        },
        {
          matter:
            "2、负责平台日常内容输出、粉丝互动管理等工作（活动运营、热点话题、爆文运营等）策划产品活动，输出文案，把控微信公众号、小红书、今日头条等推动渠道工作执行企业账号运营管理，提高用户增长和引流转化等工作；",
        },
        {
          matter: "3、建立公司内容资料库，整理产品文案定期更新，并与粉丝互动；",
        },
        {
          matter: "4、完成领导安排的其他事务。",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter:
            "1、本科以上学历，有0-1搭建新媒体平台，包括今日头条、微信公众号、小红书、抖音等运营整体思路;网感好、选题策划能力强、擅长数据分析、有涨粉、转化逻辑，了解多个新媒体平台运营规则；",
        },
        {
          matter:
            "2、优秀的沟通能力、团队管理及协作能力、执行力、有耐心、抗压能力强、思维活跃、有亲和力、了解中老年用户心理；",
        },
        {
          matter: "3、有保健品类、美妆类行业经验，食品营养学专业者优先。",
        },
      ],
    },
  ],
  two: [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "根据客户需求，市场热点寻找或定制相关产品，并对产品的生命周期进行管理。",
        },
        {
          matter:
            "1、能及时收集中老年保健品，家用医疗器械市场信息，洞察市场热点。",
        },
        {
          matter: "2、调研客户需求，能够打造爆品，挖掘潜力趋势单品。",
        },
        {
          matter:
            "3、负责供应商的维护和管理，能够与供应商的接洽、谈判，控制采购费用、降低采购成本，争取供应商的产品价格支持；",
        },
        {
          matter:
            "4、熟悉中老年市场信息，洞察客户需求，分析用户需求变化，流量结构变化，探索保健品创新型营销方案，最大化满足客户的需求；",
        },
        {
          matter:
            "5. 关注市场商品价格变化，及时更换组合，调整价格策略，及时了解、收集并反馈市场信息；",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1. 本科及以上学历，三年以上相关行业和品类的采购经验；",
        },
        {
          matter: "2. 熟悉产品管理运作流程；",
        },
        {
          matter:
            "3. 熟悉中老年保健市场供应链，对传统滋补品产品熟知，具备丰富的行业及品牌资源优先；",
        },
        {
          matter: "4. 具有洞察消费者需求的能力。",
        },
      ],
    },
  ],
  three: [
    {
      title: "【岗位职责】",
      list: [
        {
          matter: "1、熟悉会员管理体系，会员分层管理，会员全生命周期管理；",
        },
        {
          matter:
            "2、熟练掌控会员数据分析方法，可以根据现有会员数据进行活动效果分析；",
        },
        {
          matter:
            "3、熟悉会员活动策划，可以根据会员的现状特点针对性的制定会员拉新、留存、促活、裂变等的相关活动，为会员全生命周期贡献和会员中心总产出负责；",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1、本科及以上学历，两年及以上活动策划工作经验；",
        },
        {
          matter:
            "2、有同行业工作经验，或有连锁零售行业活动策划、会员管理经验的优先；",
        },
        {
          matter:
            "3、沟通表达能力佳，有较强的工作责任心，吃苦耐劳，具备良好的执行力和团队合作精神。",
        },
      ],
    },
  ],
  four: [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、根据公司产品内容运营方向和运营需求，负责公司产品宣传册、营销海报、软文内容策划和文案输出；",
        },
        {
          matter:
            "2、从客户及消费者的角度出发，深挖产品卖点，以文案形式展示优点，提示产品核心竞争力，协同设计完成产品详情描述;",
        },
        {
          matter:
            "3、结合行业热点和公司产品优势、客户案例输出具有感染力的内容；",
        },
        {
          matter: "4、根据每月营销节奏，提供活动页面文案排版及输出；",
        },
        {
          matter:
            "5、熟悉产品策划方法，对于产品卖点挖掘、目标人群痛点选定、同类竞品分析等有一套成熟的工作方法",
        },
        {
          matter:
            "6、有一定文字功底，熟练掌握软、有创意、有逻辑、硬文的各种写作方法",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter:
            "1、专科及以上学历，两年以上内容运营经验，有保健品同行业工作经验，或有化装品、医美等行业的优先；",
        },
        {
          matter: "2、有撰写产品文案的经验中文、新闻学、广告学等相关专业背景；",
        },
        {
          matter: "3、优秀的创意能力和文字功底，敏锐的洞察力；",
        },
        {
          matter: "4、策划和文案能力，文字功底深厚，同时兼备良好的视觉审美；",
        },
        {
          matter: "5、熟悉内容运营模式，对文案撰写及内容营销充满激情； ",
        },
        {
          matter:
            "6、沟通表达能力佳，有较强的工作责任心，吃苦耐劳，具备良好的执行力和团队合作精神。",
        },
      ],
    },
  ],
  five: [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、负责回访会员意向客户，评估客户需求，根据对产品的了解，向客户有针对性介绍产品优势，为会员客户提供产品推荐和服务达成销售意向。协助并跟踪解决会员客户的售前、售后问题；",
        },
        {
          matter:
            "2、根据会员情况给予健康指导能够学会管理客户，与客户保持良好沟通促进客户再次复购转化；",
        },
        {
          matter:
            "3、记录和反馈客户意见，有效进行客户关系的维护和发展，提升客户满意度和客户价值，建立长期共赢的客户合作关系； ",
        },
        {
          matter: "4、能够有效挖掘客户需求，进行开发新客户。",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1、中专或高中以上学历，有一年以上电话销售工作经验者优先；",
        },
        {
          matter:
            "2、普通话标准，沟通表达能力、亲和力佳、有较强的抗压能力、责任心、良好的工作心态、具备良好的客户服务意识，执行力和团队合作精神；",
        },
        {
          matter: "3、从事医学营养健康行业工作者优先。",
        },
      ],
    },
  ],
};
const linWidth = ref(0);
const itemClick = (v) => {
  flag.value = v;
  nextTick(() => {
    linWidth.value = widthTielt.value.clientWidth + 15;
  });
  if (v === "新媒体运营经理") {
    dutyList.splice(0, 2);
    dutyList.push(...LlisInfo.one);
    Polygon6.value.style.left = 71 + "px";
  } else if (v === "产品经理") {
    dutyList.splice(0, 2);
    dutyList.push(...LlisInfo.two);
    Polygon6.value.style.left = 254 + "px";
  } else if (v === "活动策划") {
    dutyList.splice(0, 2);
    dutyList.push(...LlisInfo.three);
    Polygon6.value.style.left = 392 + "px";
  } else if (v === "销售顾问") {
    dutyList.splice(0, 2);
    dutyList.push(...LlisInfo.five);
    Polygon6.value.style.left = 536 + "px";
  }
};
const BrandIntroduction = ref(null);
const CoreCulture = ref(null);
const JoinUs = ref(null);
const JumpShop = ref(null);
const aList = [
  { title: "官网首页", href: "FirstScreen" },
  { title: "品牌介绍", href: "BrandIntroduction" },
  { title: "企业文化", href: "CoreCulture" },
  { title: "资质荣誉", href: "qualification" },
  { title: "加入我们", href: "JoinUs" },
  { title: "商城首页", href: "JumpShop" },
];
let isAshow = ref("FirstScreen");
const Maodian = (v) => {
  firstShow.value = true;
  isAshow.value = v;
  nextTick(() => {
    document.getElementById(v).scrollIntoView();
  });
};
const menuinfoflag = ref(0);
const menuinfo = (e) => {
  return;
  console.log(123);
  // FirstScreen.value.style.opacity = 0;
  var scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  // console.log(scrollTop, "scrollTop");
  // console.log(e.wheelDelta);
  if (e.wheelDelta > 0) {
    console.log("e.wheelDelta > 0");
    //向上滚动
    // if (scrollTop < 10) {
    // firstShow.value = false;
    // menuinfoflag.value = 1;
    // setTimeout(() => {
    //   // nextTick(() => {
    //   //   if (FirstScreen.value && FirstScreen.value.style) {
    //   //     FirstScreen.value.style.opacity = 1;
    //   //   }
    //   // });
    // }, 300);
    // }
  }
  if (e.wheelDelta < 0) {
    // if (FirstScreen.value && FirstScreen.value.style) {
    //   FirstScreen.value.style.opacity = 0;
    //   // FirstScreen.value.style.opacity = 1;
    //   let FirstHieght = FirstScreen.value.offsetHeight;
    // document.documentElement.scrollTop = 900;
    // }
    // setTimeout(() => {
    //   firstShow.value = true;
    // }, 1000);
  }
};
let shipinjingying = require("@/assets/Certificat/shipinjingying.jpg");
let hulianwang = require("@/assets/Certificat/hulianwang.jpg");
let jingshiyaowang = require("@/assets/Certificat/jingshiyaowang.jpg");
let yiliaoqixie = require("@/assets/Certificat/yiliaoqixie.png");
let yingyezhizhao = require("@/assets/Certificat/yingyezhizhao.jpg");
const watchVideo = () => {
  // window.open(mp4, "_blank");
  isVideo.value = true;
};
const backShop = (v) => {
  // if (!v) {
  //   self.location.href = "http://shop.jjlg.com.cn/";
  // } else {
  //   self.location.href = "http://shop.jjlg.com.hk/";
  // }
  
};
const headerinfo = ref(null);
const navbarbox = ref(null);
const mainbox = ref(null);
const futitle = ref(null);
const hxwhref = ref(null);
const qywwxsloaan = ref(null);
const qyimgContent = ref(null);
const headerzz = ref(null);
const contentinfomain = ref(null);
const JoinUsContenttitile = ref(null);
const navContent = ref(null);
const cardinfoq = ref(null);
const PhotoWall = ref(null);
const hrinfo = ref(null);
const scrolltopi = ref(0);

const stopUpDownFunList = (awaitTime = 300) => {
  let startTimer = 0;
  //节流  一段时间只能执行一次 使用时间戳控制
  const retrunStopUpDown = (fun, ...arrAgu) => {
    if (typeof fun !== "function") return;
    let endTimer = new Date().getTime();
    if (endTimer - startTimer > awaitTime) {
      fun(...arrAgu);
      startTimer = new Date().getTime();
    }
  };
  return retrunStopUpDown;
};
const stopUpDownFun = stopUpDownFunList();
const topflootContent = ref(null);
const handleScroll = () => {
  const divs = [];
  const FirstScreen = document.getElementById("FirstScreen");
  const BrandIntroduction = document.getElementById("BrandIntroduction");
  const CoreCulture = document.getElementById("CoreCulture");
  const qualification = document.getElementById("qualification");
  const JoinUs = document.getElementById("JoinUs");
  const JumpShop = document.getElementById("JumpShop");
  // console.log(FirstScreen,'FirstScreen')
  // console.log(FirstScreen.value.offsetHeight); //获取元素高度
  // console.log(navbarbox.value.offsetTop); //
  // console.log(document.documentElement.scrollTop, 1);
  // document.documentElement.scrollTop  = 999
  // stopUpDownFun((...data) => {
  // });
  let scroll = document.documentElement.scrollTop - scrolltopi.value;
  scrolltopi.value = document.documentElement.scrollTop;
  // console.log(scroll);
  // console.log(scrolltopi.value);
  // console.log(FirstScreen.offsetHeight)
  //向下滚动条
  // console.log(document.documentElement.s15rollTop )
  if (document.documentElement.scrollTop >= 100) {
    topflootContent.value.style.opacity = 0;
  } else if (document.documentElement.scrollTop < 210) {
    topflootContent.value.style.opacity = 1;
  }
  if (document.documentElement.scrollTop >= 100) {
    nextTick(() => {
      headerinfo.value.style.transform = "translate(0px, 0px)";
      headerinfo.value.style.opacity = "1";
      headerinfo.value.style.zIndex = "1";
      headerinfo.value.style.visibility = "visible";
    });
  }
  if (document.documentElement.scrollTop >= 120) {
    navbarbox.value.style.transform = "translate(0px, 0px)";
    navbarbox.value.style.opacity = "1";
    navbarbox.value.style.zIndex = "1";
    navbarbox.value.style.visibility = "visible";
    hrinfo.value.style.transform = "translate(0px, 0px)";
    hrinfo.value.style.opacity = "1";
    hrinfo.value.style.zIndex = "1";
    hrinfo.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 220) {
    futitle.value.style.transform = "translate(0px, 0px)";
    futitle.value.style.opacity = "1";
    futitle.value.style.zIndex = "1";
    futitle.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 290) {
    nextTick(() => {
      mainbox.value.style.transform = "translate(0px, 0px)";
      mainbox.value.style.opacity = "1";
      mainbox.value.style.zIndex = "1";
      mainbox.value.style.visibility = "visible";
    });
  }
  if (document.documentElement.scrollTop >= 780) {
    hxwhref.value.style.transform = "translate(0px, 0px)";
    hxwhref.value.style.opacity = "1";
    hxwhref.value.style.zIndex = "1";
    hxwhref.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 831) {
    qywwxsloaan.value.style.transform = "translate(0px, 0px)";
    qywwxsloaan.value.style.opacity = "1";
    qywwxsloaan.value.style.zIndex = "1";
    qywwxsloaan.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 947) {
    qyimgContent.value.style.transform = "translate(0px, 0px)";
    qyimgContent.value.style.opacity = "1";
    qyimgContent.value.style.zIndex = "1";
    qyimgContent.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 1650) {
    headerzz.value.style.transform = "translate(0px, 0px)";
    headerzz.value.style.opacity = "1";
    headerzz.value.style.zIndex = "1";
    headerzz.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 1885) {
    // console.log(mainitemt);
    contentinfomain.value.style.transform = "translate(0px, 0px)";
    contentinfomain.value.style.opacity = "1";
    contentinfomain.value.style.zIndex = "1";
    contentinfomain.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 3037) {
    // console.log(mainitemt);
    JoinUsContenttitile.value.style.transform = "translate(0px, 0px)";
    JoinUsContenttitile.value.style.opacity = "1";
    JoinUsContenttitile.value.style.zIndex = "1";
    JoinUsContenttitile.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 3115) {
    // console.log(mainitemt);
    navContent.value.style.transform = "translate(0px, 0px)";
    navContent.value.style.opacity = "1";
    navContent.value.style.zIndex = "1";
    navContent.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 3192) {
    // console.log(mainitemt);
    cardinfoq.value.style.transform = "translate(0px, 0px)";
    cardinfoq.value.style.opacity = "1";
    cardinfoq.value.style.zIndex = "1";
    cardinfoq.value.style.visibility = "visible";
  }
  if (document.documentElement.scrollTop >= 3784) {
    // console.log(mainitemt);
    PhotoWall.value.style.transform = "translate(0px, 0px)";
    PhotoWall.value.style.opacity = "1";
    PhotoWall.value.style.zIndex = "1";
    PhotoWall.value.style.visibility = "visible";
  }
  // 3192
  divs.push(
    ...[
      FirstScreen,
      BrandIntroduction,
      CoreCulture,
      qualification,
      JoinUs,
      JumpShop,
    ]
  );

  const offsetTopArr = [];
  divs.forEach((item) => {
    // offsetTopArr.push(item.offsetTop - 80);
    offsetTopArr.push(item.offsetHeight);
    // console.log(item)
  });
  // console.log(divs,'divs')
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  // console.log(offsetTopArr);
  // [80, 533, 1386, 2590]
  // [677, 666, 853, 1396, 1207, 547]
  let navIndex = 0;
  // console.log(scrollTop);
  if (scrollTop >= 0 && scrollTop < offsetTopArr[0]) {
    isAshow.value = "FirstScreen";
  } else if (
    scrollTop >= offsetTopArr[0] &&
    scrollTop < offsetTopArr[0] + offsetTopArr[1]
  ) {
    isAshow.value = "BrandIntroduction";
  } else if (
    scrollTop >= offsetTopArr[0] + offsetTopArr[1] &&
    scrollTop < offsetTopArr[0] + offsetTopArr[1] + offsetTopArr[2]
  ) {
    isAshow.value = "CoreCulture";
  } else if (
    scrollTop >= offsetTopArr[0] + offsetTopArr[1] + offsetTopArr[2] &&
    scrollTop <
      offsetTopArr[0] + offsetTopArr[1] + offsetTopArr[2] + offsetTopArr[3]
  ) {
    isAshow.value = "qualification";
  } else if (
    scrollTop >=
      offsetTopArr[0] + offsetTopArr[1] + offsetTopArr[2] + offsetTopArr[3] &&
    scrollTop <
      offsetTopArr[0] +
        offsetTopArr[1] +
        offsetTopArr[2] +
        offsetTopArr[3] +
        offsetTopArr[4] -
        50
  ) {
    isAshow.value = "JoinUs";
  } else if (
    scrollTop >=
    offsetTopArr[0] +
      offsetTopArr[1] +
      offsetTopArr[2] +
      offsetTopArr[3] +
      offsetTopArr[4] -
      100
  ) {
    isAshow.value = "JumpShop";
  }
  // console.log(document.documentElement.scrollTop);
  // else if (scrollTop >= 533 && scrollTop < 1305) {
  //   isAshow.value = "CoreCulture";
  // } else if (scrollTop < 5) {
  //   isAshow.value = "BrandIntroduction";
  // } else if (scrollTop >= 1305 && scrollTop < 2400) {
  //   isAshow.value = "JoinUs";
  // } else if (scrollTop >= 2400) {
  //   isAshow.value = "JumpShop";
  // }
  // for (let n = 0; n < offsetTopArr.length; n++) {
  // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
  // 那么此时导航索引就应该是 n 了
  // if (scrollTop >= offsetTopArr[n]) {
  //   navIndex = n;
  // }
  // }
  // 把下标赋值给 vue 的 data
  // console.log(navIndex)
  // this.currentIndex = navIndex;
  // console.log(BrandIntroduction);
  // console.log(CoreCulture);
};
const year = ref('')
onMounted(() => {
  let date = new Date()
  year.value = date.getFullYear()
  // nextTick(() => {
  //   document.documentElement.scrollTop = 900;
  // });
  // if (document.addEventListener) {
  //   //firefox
  //   document.addEventListener("mousewheel", menuinfo, false);
  // } else {
  window.onmousewheel = menuinfo;
  // }
  // window.onmousewheel = () => {
  //   // nextTick(() => {
  //   //   document.documentElement.scrollTop = 900;
  //   // });
  //   // console.log(123)
  // };

  window.addEventListener("scroll", handleScroll, false);
});
// 品牌介绍
const pplist = reactive([
  { title: "公司基本情况介绍" },
  { title: "公司业务发展情况" },
  { title: "公司业务未来展望" },
]);
const ppcurrentindex = ref(0);
const pptitle = ref("公司基本情况介绍");
const ppclick = (t, i) => {
  ppcurrentindex.value = i;
  pptitle.value = t;
  nextTick(() => {
    mainbox.value.style.transform = "translate(0px, 0px)";
    mainbox.value.style.opacity = "1";
    mainbox.value.style.zIndex = "1";
    mainbox.value.style.visibility = "visible";
  });
};
// 资质荣誉
const qualificationList = reactive([
  { date: "2011.03", content: "荣获“2010电商TOP50”客户价值管理奖。 " },
  {
    date: "2011.04",
    content:
      "荣获由商务部、亚太经济合作组织（APEC）主办“2011亚太电子商务绿色经济发展峰会暨第二届电子商务年会”优秀企业奖。",
  },
  { date: "2011.05", content: "荣获“易观”客户价值最佳管理奖。" },
  { date: "2014.12", content: "获国家高新技术企业资质。" },
  {
    date: "2015.06",
    content: "被列为北京市科技型中小企业创新基金政府支持项目 。",
  },
  { date: "2015.11", content: "荣登“2015快公司TOP100”的榜单 。" },
  { date: "2015.12", content: "被经济观察报评为“花蕾之约40强企业”。" },
  {
    date: "2016.01",
    content: "中关村移动互联网产业联盟评为2015年度最具潜力移动医疗APP。",
  },
  {
    date: "2016.01",
    content: "荣获2015年度中国互联网+创新奖之最佳媒体口碑奖。",
  },
  {
    date: "2016.02",
    content: "荣登第一届互联网医健年度风云榜之最受关注新锐企业榜。",
  },
  { date: "2016.05", content: "荣获2016年春季移动医疗APP黑马奖。" },
  { date: "2016.06", content: "荣登《中国企业家》2016最具成长性企业萌芽榜。" },
  { date: "2016.09", content: "荣获红鲱鱼2016年亚太科技企业100强。" },
  { date: "2016.11", content: "荣获红鲱鱼2016年全球科技企业100强 。" },
  { date: "2016.12", content: "荣获“未来医疗100强”荣誉称号 。" },
  { date: "2021.03", content: "荣获天猫国际最佳用户体验奖。" },
]);
watch(firstShow, (n, o) => {
  // console.log(n,o)
  if (n) {
    isAshow.value = "BrandIntroduction";
  } else {
    isAshow.value = "";
  }
});
</script>

<style lang="less" scoped>
@w: 1190px;
.MainPageContent {
  // height: 100vh;
  // overflow-y: scroll;
  .headerBox {
    width: 100%;
    height: 80px;
    background: #fff;
    position: fixed;
    top: 0;
    z-index: 9999;
    box-shadow: 0px 3px 12px rgba(70, 81, 60, 0.08);
    .headerContent {
      width: 1190px;
      // background: orange;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        width: 140px;
        height: 59px;
      }
      .rightnav {
        // width: 539px;
        height: 36px;
        // background-color: tomato;
        text-align: right;
        display: flex;
        .aboxinfo {
          position: relative;
          margin-right: 20px;
          a {
            color: #282b26;
            font-weight: 400;
            font-size: 16px;
            // font-family: "Hiragino Sans GB";
            line-height: 36px;
            margin-right: 13px;
            // cursor: pointer;
            // cursor: url(../assets/shubiao.ico), default;
            cursor: pointer;
            &:hover {
              color: #54b000;
            }
          }
          .lineinfo {
            position: absolute;
            left: 50%;
            transform: translateX(-70%);
            bottom: 0;
            width: 22px;
            height: 2px;
            background: #6fba2c;
            border-radius: 34px;
          }
        }

        span {
          color: #282b26;
          font-weight: 400;
          font-size: 16px;
          font-family: "Hiragino Sans GB";
          line-height: 36px;
          margin-right: 13px;
          cursor: pointer;
        }
      }
    }
  }
  .FirstScreen {
    width: 100%;
    height: calc(100vh - 80px);
    background-image: url("@/assets/backgroundimg.png");
    background-position: center;
    background-size: cover;
    position: relative;
    transition: all 1s;
    [v-cloak] {
      display: none !important;
    }
    .Mouse {
      position: absolute;
      left: 50%;
      bottom: 127px;
      transform: translateX(-50%);
      animation: opacity 3s ease-out infinite;
    }
    @keyframes opacity {
      0% {
        opacity: 1;
        bottom: 127px;
      }
      100% {
        opacity: 0;
        bottom: 137px;
      }
    }
    .flootContent {
      position: absolute;
      width: 100%;
      height: 97px;
      left: 0px;
      bottom: 0;
      background: rgba(255, 255, 255, 0.64);
      opacity: 1;
      backdrop-filter: blur(24px);
      transition: all 1s;
      .closeinfo {
        position: absolute;
        top: 4px;
        right: 11px;
      }
      .banner_footer {
        width: 1053px;
        // height: 30px;
        // background: orange;
        margin: 0 auto;
        margin-top: 12px;
        p {
          text-align: center;
          a {
            font-size: 12px;
            text-decoration: none;
            color: #282b26;
            &:hover {
              color: #54b000;
            }
          }
        }
      }
      .banner_footerImg {
        width: 190px;
        // background: #282b26;
        margin: 0 auto;
        margin-top: 8px;

        .rightimg {
          margin-left: 44px;
        }
      }
      .closeIcon {
        position: absolute;
        top: 5px;
        right: 11px;
        cursor: pointer;
      }
    }
  }
  .BrandIntroduction {
    width: 100%;

    // height:408px;
    // background: #fff;
    // background: orange;
    padding: 70px 0 90px 0;
    box-sizing: border-box;
    .BrandIntroductionBox {
      width: @w;
      // background: #95a5a6;
      margin: 0 auto;
      // display: flex;
      // align-items: flex-end;
      .headerinfo {
        color: #282b26;
        font-weight: 600;
        font-size: 30px;
        text-align: center;
        width: 100%;
      }
      .navbarbox {
        width: 562px;
        // background: #7bed9f;
        margin: 0 auto;
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        color: #282b26;
        font-weight: 300;
        font-size: 16px;
        .navitem {
          cursor: pointer;
          position: relative;
          .luxian {
            position: absolute;
            left: 51px;
            top: 31px;
            width: 47px;
            height: 5px;
            background: #6fba2c;
            border-radius: 48px;
          }
        }
      }
      .hrinfo {
        width: 100%;
        height: 1px;
        background: #e0e0e0;
        margin-top: 11px;
      }
      .futitle {
        color: #60635c;
        font-weight: 600;
        font-size: 18px;
        margin-top: 45px;
      }
      .mainbox {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .textbox {
          width: 785px;
          color: #6c7169;
          font-weight: 300;
          font-size: 15px;
          letter-spacing: 0.04em;
          & > p {
            line-height: 28px;
            text-indent: 30px;
          }
        }
        .imgbox {
          display: flex;
          flex-direction: column;
          margin-left: 36px;
        }
      }
    }
  }
  .CoreCulture {
    width: 100%;
    height: 853px;
    background-image: url("@/assets/shan.png");
    background-position: center;
    background-size: cover;
    padding-top: 80px;
    box-sizing: border-box;
    .CoreCultureContent {
      width: @w;
      margin: 0 auto;
      .title {
        color: #282b26;
        font-weight: 700;
        font-size: 26px;
      }
      .slogan {
        width: 660px;
        height: 86px;
        margin-top: 34px;
        margin-left: 75px;
        .text {
          color: #6c7169;
          font-size: 20px;
          margin-top: 22px;
        }
      }
      .imgContent {
        width: @w;
        height: 419px;
        margin-top: 34px;
        display: flex;
        align-items: center;
        padding-top: 60px;
        box-sizing: border-box;
        // background: #333;
        .imgItem {
          display: flex;
          flex-direction: column;
          align-items: center;
          .h1 {
            color: #5b5c5b;
            font-weight: 400;
            font-size: 17px;
            margin-top: 24px;
            margin-bottom: 8px;
          }
          .h2 {
            color: #6fba2c;
            font-weight: 700;
            letter-spacing: 0.13em;
            font-size: 21px;
          }
        }
      }
    }
  }
  .qualification {
    width: 100%;
    // height: 1221px;
    background-image: url("@/assets/zzrybgc.png");
    background-position: center;
    background-size: cover;
    box-sizing: border-box;
    padding: 60px 0 70px 0;
    // background: #000;
    .qualificationContent {
      width: @w;
      // background: orange;
      margin: 0 auto;
      .headerzz {
        width: 416px;
        color: #282b26;
        font-weight: 600;
        font-size: 32px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .contentinfomain {
        margin-top: 50px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .mainitemt {
          width: 585px;
          // height: 120px;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 3px 14px rgba(70, 81, 60, 0.15);
          border-radius: 19px;
          // backdrop-filter: blur(15px);
          margin-bottom: 20px;
          padding: 24px 32px 20px 32px;
          box-sizing: border-box;
          display: inline-block;
          letter-spacing: 0.04em;
          .dateinfo {
            color: #6fba2c;
            font-weight: 600;
            font-size: 20px;
          }
          .infocontenta {
            width: 521px;
            color: #6c7169;
            font-weight: 300;
            font-size: 15px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .JoinUs {
    padding-top: 85px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .JoinUsContent {
      width: @w;
      // height: 1134px;
      background: #fff;
      // background: orange;
      margin: 0 auto;
      .title {
        color: #282b26;
        font-weight: 700;
        font-size: 26px;
        font-family: "Hiragino Sans GB";
      }
      .navContent {
        width: 528px;
        // background: #55efc4;
        display: flex;
        margin-top: 40px;
        margin-left: 50px;
        justify-content: space-between;
        .item {
          color: #282b26;
          font-family: "Hiragino Sans GB";
          font-weight: 400;
          font-size: 16px;
          cursor: pointer;
        }
        .showColor {
          color: #6fba2c;
        }
      }
      .card {
        width: 100%;
        // height: 439px;
        min-height: 439px;
        box-shadow: 0px 3px 14px rgba(70, 81, 60, 0.15);
        border: 1px solid #e0e0e0;
        border-radius: 44px;
        margin-top: 30px;
        position: relative;
        padding: 44px 0 40px 60px;
        box-sizing: border-box;
        .Rectangle32 {
          position: absolute;
          top: -10px;
          right: 10px;
          width: 381px;
          height: 118px;
          z-index: 3;
        }
        .Maskyuanjaigroup {
          position: absolute;
          top: -12px;
          right: -8px;
          width: 399px;
          height: 120px;
          z-index: 4;
        }
        .zhongc {
          position: absolute;
          top: 0px;
          right: -10px;
          width: 382px;
          height: 107px;
          background: #ffffff;
          // background: orange;
          z-index: 2;
        }
        .E-mail {
          // position: absolute;
          // top: 8px;
          // right: 47px;
          // z-index: 9;
          // color: #ffffff;
          // font-weight: 700;
          // font-size: 24px;
        }
        .Polygon6 {
          position: absolute;
          top: -13px;
          left: 71px;
          z-index: 9;
          transition: all 0.5s;
        }
        .title {
          // width: 141px;
          margin-left: 7px;
          text-align: center;
          font-family: "Hiragino Sans GB";
          font-weight: 700;
          font-size: 18px;
          display: inline-block;
          color: #60635c;
        }

        .line {
          width: 141px;
          height: 8px;
          background: #6fba2c;
          border-radius: 62px;
          margin-top: -8px;
          // margin-left: -6px;
        }
        .duty {
          color: #282b26;
          font-family: "Hiragino Sans GB";
          font-weight: 700;
          font-size: 16px;
          margin-top: 20px;
        }
        .dutyBox {
          width: 907px;
          margin-top: 10px;
          .dutyitem {
            color: #6c7169;
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 0.04em;
            line-height: 28px;
          }
        }
        .E-mail {
          margin-top: 20px;
        }
      }
      .PhotoWall {
        // background: orange;
        height: 343px;
        width: @w;
        margin-top: 34px;
        display: flex;
        .left {
          width: 296px;
          height: 343px;
        }
        .right {
          .top {
            img {
              margin-left: 15px;
            }
          }
          .bottom {
            margin-top: 15px;
            margin-left: 15px;
            .Maskgroup5 {
              margin-left: 17px;
            }
          }
        }
      }
    }
  }
  .maskImg {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99999999;
    background: rgba(255, 255, 255, 0.68);
    backdrop-filter: blur(15px);
    .imgbox {
      width: 753px;
      height: 568px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .maskimg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // background: url('@/assets/zhaopq/i10.jpg');
        // background-size: contain;
      }
      .close {
        width: 30px;
        height: 30px;
        position: absolute;
        right: -40px;
        top: -40px;
        cursor: pointer;
        // background: yellowgreen;
      }
      .w {
        width: 51px;
        height: 134px;
        background: rgba(0, 0, 0, 0.3);

        cursor: pointer;
        color: #fff;
        text-align: center;
        line-height: 134px;
        user-select: none;
      }
      .left {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -55px;
      }
      .right {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: -55px;
      }
    }
  }
  .JumpShop {
    width: 100%;
    // height: 513px;
    // height: calc(100vh -100px);
    height: calc(100vh - 210px);
    background: url("@/assets/image14.jpg");
    background-position: center;
    background-size: cover;
    position: relative;
    .JumpShopContent {
      width: @w;
      // height: 913px;
      margin: 0 auto;
      position: relative;
      .leftBox {
        position: absolute;
        left: 0;
        top: 70px;
        cursor: pointer;
        .title {
          color: #ffffff;
          font-weight: 700;
          // font-family: FZLTXIHJW;
          font-family: "Hiragino Sans GB";
          font-size: 40px;
        }
        .bottombox {
          display: flex;
          .leftinfo {
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            margin-right: 10px;
          }
          .tiaoxaingtou {
            animation: moveRight 2s linear infinite;
            position: relative;
          }
          @keyframes moveRight {
            0% {
              right: 0;
              opacity: 1;
            }
            100% {
              right: -20%;
              opacity: 0;
            }
          }
        }
      }
      .rightBox {
        position: absolute;
        right: 0;
        top: 70px;
        cursor: pointer;
        .title {
          color: #ffffff;
          font-weight: 700;
          font-size: 42px;
          // font-family: FZLTXIHJW;
          font-family: "Hiragino Sans GB";
        }
        .bottombox {
          display: flex;
          .leftinfo {
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            margin-right: 10px;
          }

          .tiaoxaingtou {
            animation: moveRight 2s linear infinite;
            position: relative;
          }
          @keyframes moveRight {
            0% {
              right: 0;
              opacity: 1;
            }
            100% {
              right: -20%;
              opacity: 0;
            }
          }
        }
      }
    }
  }
  .flootContent {
    width: 100%;
    height: 97px;
    margin-top: 0px;
    background: rgba(255, 255, 255, 0.74);
    backdrop-filter: blur(24px);
    .banner_footer {
      width: 1053px;
      // height: 30px;
      // background: orange;
      margin: 0 auto;
      margin-top: 12px;
      p {
        text-align: center;
        a {
          font-size: 12px;
          text-decoration: none;
          color: #282b26;
          &:hover {
            color: #6fba2c;
          }
        }
        .jwga {
          margin: 0 10px;
          cursor: pointer;
        }
        span {
          font-size: 12px;
          text-decoration: none;
          color: #282b26;
        }
      }
    }
    .banner_footerImg {
      width: 190px;
      // background: #282b26;
      margin: 0 auto;
      margin-top: 8px;

      .rightimg {
        margin-left: 44px;
      }
    }
    .closeIcon {
      position: absolute;
      top: 5px;
      right: 11px;
      cursor: pointer;
    }
  }
  .showdh {
    transform: translate(0px, 100px);
    transition: all 600ms ease-in-out 0s;
    opacity: 0;
    visibility: hidden;
    z-index: 0;
  }
  .Hide {
    transform: translate(0px, 0px) !important;
    transition: all 600ms ease-in-out 0s;
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 1 !important;
  }
}
</style>
